module.exports = __webpack_public_path__ + "media/images/Integration-e2a17e20.png";